import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Model from "./Model";
export default class OrderComment extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'call_agent_order_comment_id',
      fieldTitle: 'Comment id',
      content: null
    });
    _defineProperty(this, "OrderCommentCallAgent", {
      fieldName: 'call_agent_order_comment_call_agent',
      fieldTitle: 'Comment call agent',
      content: null
    });
    _defineProperty(this, "OrderCommentOrder", {
      fieldName: 'call_agent_order_comment_order',
      fieldTitle: 'Comment order',
      content: null
    });
    _defineProperty(this, "OrderCommentComment", {
      fieldName: 'call_agent_order_comment_comment',
      fieldTitle: 'Comment content',
      content: null
    });
    _defineProperty(this, "OrderCommentStatus", {
      fieldName: 'call_agent_order_comment_status',
      fieldTitle: 'Comment status',
      content: null
    });
    _defineProperty(this, "OrderCommentCreationDate", {
      fieldName: 'created_at',
      fieldTitle: 'Comment creation date',
      content: null
    });
  }
  getStatus() {
    return this.OrderCommentStatus.content;
  }
  getComment() {
    return this.OrderCommentComment.content;
  }
  getCreationDate() {
    return this.OrderCommentCreationDate.content;
  }
}